import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { AuthApiService } from '../services/auth/auth-api.service';

const HTTP_UNAUTHORIZED = 401;
let isRefreshing = false;

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthApiService);
  const router = inject(Router);

  if (req.url.includes('/register') || req.url.includes('/login') || req.url.includes('/oauth2') || req.url.includes('/login/oauth2')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === HTTP_UNAUTHORIZED) {
        if (req.url.includes('/auth/refresh')) {
          authService.logout$().subscribe(() => {
            router.navigate(['/']);
          });
          return throwError(() => error);
        }

        if (!isRefreshing) {
          isRefreshing = true;

          const refreshToken = authService.getRefreshToken();

          if (!refreshToken) {
            isRefreshing = false;
            authService.logout$().subscribe(() => {
              router.navigate(['/']);
            });
            return throwError(() => error);
          }

          return authService.refreshTokens$(refreshToken).pipe(
            switchMap((newAccessToken: string) => {
              isRefreshing = false;

              const newHeaders = req.headers.set('Authorization', `Bearer ${newAccessToken}`);
              const clonedRequest = req.clone({ headers: newHeaders });
              return next(clonedRequest);
            }),
            catchError(refreshError => {
              isRefreshing = false;
              authService.logout$().subscribe(() => {
                router.navigate(['/']);
              });
              return throwError(() => refreshError);
            })
          );
        }
      }

      return throwError(() => error);
    })
  );
};
